import { useApiStore } from '@eigtech/ui-shared-api'
import { Center, CircularProgress, GenericErrorBoundaryComponent } from '@eigtech/ui-shared-dave'
import { Sentry, initSentry } from '@eigtech/ui-shared-sentry'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import 'mapbox-gl/dist/mapbox-gl.css'
import { createRoot } from 'react-dom/client'
import { version } from '../package.json'
import './lib/utils/heap'
import { apiInstance } from './api/instance'
import { routeTree } from './routeTree.gen'
import { queryClient } from './store/queryClient'

// The white label theme is loaded in the root route's loader, before any provider
// mounts. ApiInstanceProvider only registers the instance in an effect, which is too
// late for that, so register it up front - it sets the same instance again later.
useApiStore.getState().setInstance(apiInstance)

// Set up a Router instance
const router = createRouter({
  routeTree,
  // defaultPreload: 'intent',
  defaultPendingComponent: () => (
    <Center>
      <CircularProgress isIndeterminate size={100} />
    </Center>
  ),
  context: {
    queryClient,
  },
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
})

initSentry({
  release: `ui-delegate@${version}`,
  router,
})

// Register things for typesafety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
declare module '@eigtech/ui-shared-router' {
  interface Register {
    router: typeof router
  }
}

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

root.render(
  <Sentry.ErrorBoundary fallback={GenericErrorBoundaryComponent}>
    <RouterProvider router={router} />
  </Sentry.ErrorBoundary>
)
